import React from "react";
import HomePage from "./pages/HomePage";
import "./styles.css";

const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
};

export default App;
